import { useMediaQuery } from "./use-media-query";

export const useIsMobile = () => {
  const isMobile = useMediaQuery('(max-width: 740px)');
  return isMobile;
}